import { render, staticRenderFns } from "./twitterCard.vue?vue&type=template&id=80238dd2&"
import script from "./twitterCard.vue?vue&type=script&lang=js&"
export * from "./twitterCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports